"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var table_row_1 = require("../../../model/table-row");
var Subject_1 = require("rxjs/Subject");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var HierarchicalTableTreeNodeComponent = /** @class */ (function () {
    function HierarchicalTableTreeNodeComponent() {
        this.columnData = [];
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], HierarchicalTableTreeNodeComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_dynamic_forms_ui_1.DynamicFormComponent)
    ], HierarchicalTableTreeNodeComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalTableTreeNodeComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalTableTreeNodeComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "subEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "subEntitySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "mainEntityCategoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "mainEntityImageFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "mainEntityFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalTableTreeNodeComponent.prototype, "customTableActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HierarchicalTableTreeNodeComponent.prototype, "showDeleteButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalTableTreeNodeComponent.prototype, "editFormId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "rootTableTitle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", table_row_1.TableRow)
    ], HierarchicalTableTreeNodeComponent.prototype, "tableRow", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalTableTreeNodeComponent.prototype, "columnData", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], HierarchicalTableTreeNodeComponent.prototype, "cellCounts", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], HierarchicalTableTreeNodeComponent.prototype, "level", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "groupByCategoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Subject_1.Subject)
    ], HierarchicalTableTreeNodeComponent.prototype, "entityNavigationSubject", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Subject_1.Subject)
    ], HierarchicalTableTreeNodeComponent.prototype, "afterTableActionSubject", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalTableTreeNodeComponent.prototype, "idPrefix", void 0);
    HierarchicalTableTreeNodeComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-hierarchical-table-tree-node',
            template: require('./hierarchical-table-tree-node.component.html'),
            styles: [require('./hierarchical-table-tree-node.component.scss')]
        })
    ], HierarchicalTableTreeNodeComponent);
    return HierarchicalTableTreeNodeComponent;
}());
exports.HierarchicalTableTreeNodeComponent = HierarchicalTableTreeNodeComponent;
//# sourceMappingURL=hierarchical-table-tree-node.component.js.map